import { typography } from 'assets/styles'
import styled, { createGlobalStyle } from 'styled-components'

export const MainContainerOverride = createGlobalStyle`
    main {
        max-width: none;
        margin-top: 62px;
        padding-right: 0px;
        padding-left: 0px;
    }
`

export const HeaderContainer = styled.div`
    ${typography.BodyCopy16}
    background-color: var(--legend-dashboard-header-background-color);
    width: 100%;
    height: 100%;
`

export const HeaderInnerContainer = styled.div`
    max-width: 1200px;
    height: 70px;
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: auto;
    margin-right: auto;

    h2 {
        display: none;
    }
`

export const HeaderLeft = styled.div`
    justify-content: flex-start;

    svg {
        color: white;
        width: 200px;
        height: 60px;
    }
`

export const HeaderCenter = styled.div`
    justify-content: center;
    color: white;
`

export const HeaderStatsText = styled.p`
    ${typography.Heading20Bold}
    font-weight: bold;

    span.date {
        color: var(--legend-dashboard-primary-color);
    }
`

export const HeaderRight = styled.div`
    justify-content: flex-end;
    color: white;
    position: relative;
    top: -1px;

    svg {
        position: relative;
        top: -2px;
        color: white;
        width: 110px;
        height: 18px;
    }
`

export const LoyaltyStatusText = styled.p`
    ${typography.BodyCopy12}
    text-transform: uppercase;
    line-height: 0px;
`
